import React from 'react';

const Dashboard = () => {
  return (
    <div>
      <h1>Dashboard</h1>
      <p>Overview of system activity and user statistics.</p>
    </div>
  );
};

export default Dashboard;